var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main"},[_c('SmartphonePreviewComponent',{attrs:{"background-image":_vm.backgroundImage,"special-offer":_vm.specialOffer,"video-content":_vm.videoContent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }